module.exports = __webpack_public_path__ + "d0134ecd3b623cc2ef1641dcdd331fcd.svg";